export const zeroPad = (num: number, length: number) => ("0000000000" + num).slice(-length);

export const str = (v: any): string => (v ? String(v) : "");
export const int = (v: any): number => (v && parseInt(v)) || 0;
export const float = (v: any): number => (v && parseFloat(v)) || 0;
export const isStr = (v: any): boolean => Boolean(v && (typeof v === "string" || v instanceof String));
export const isNum = (v?: any): boolean => !isNaN(parseInt(v));
export const arr2Len = (arr: Array<any>): number => (Array.isArray(arr) ? arr.length : 0);
